export default __webpack_public_path__ + "static/media/cc1.0401d06d.svg";